import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { getZoneConnectionRateById } from '@/lib/api/zone-connection-rates'
import ZoneConnectionRatesForm from '@/components/forms/zone-connection-rates-form'
import { Header } from '@/components/header'

export const Route = createFileRoute(
  '/_home/zone-settings/zone-connection-rates/edit/$id',
)({
  loader: async ({ params: { id } }) => {
    return { id }
  },
  component: EditZoneConnectionRatePage,
})

function EditZoneConnectionRatePage() {
  const { id } = Route.useLoaderData()
  const zoneConnectionRateId = Number(id)
  const { data: zoneConnectionRateById, isLoading } = useQuery({
    queryKey: ['getZoneConnectionRateById'],
    queryFn: () => getZoneConnectionRateById(zoneConnectionRateId),
  })

  return (
    <main className="space-y-4 p-4">
      <Header
        subroutes={[
          {
            route: '/zone-settings/zone-connection-rates',
            label: 'Zone connection rates',
          },
        ]}
      >
        Edit Zone Connection Rate
      </Header>
    </main>
  )
}
